import { TPRICE_TABLE_BODY } from '.';
import { CheckMarkCircle } from '../../Icons/checkCircle';

export const getItrType = {
  prod_self_itr_5: 'ITR 1 or 4',
  prod_self_itr_1: 'ITR 1 or 4',
  prod_self_itr_8: 'ITR 2 or 3',
  prod_self_itr_2: 'ITR 2 or 3',
  prod_self_itr_3: 'ITR 2 or 3',
  prod_self_itr_6: 'ITR 2 or 3',
};

const checkMarkComp = <CheckMarkCircle opacity={0.2} />;

export const ITR_PRICE_TABLE_BODY: TPRICE_TABLE_BODY[] = [
  {
    income: 'Taxable Income < 5L',
    columns: [checkMarkComp, null, checkMarkComp, null, checkMarkComp],
  },
  {
    income: 'Taxable Income > 5L',
    columns: [null, checkMarkComp, null, checkMarkComp, checkMarkComp],
  },
  {
    income: 'Self Employed Income',
    columns: [
      checkMarkComp,
      checkMarkComp,
      checkMarkComp,
      checkMarkComp,
      checkMarkComp,
    ],
  },
  {
    income: 'Business Income',
    columns: [null, null, checkMarkComp, checkMarkComp, checkMarkComp],
  },
  {
    income: 'Capital Gains (Indian)',
    columns: [null, null, checkMarkComp, checkMarkComp, checkMarkComp],
  },
  {
    income: 'Crypto Income',
    columns: [null, null, checkMarkComp, checkMarkComp, checkMarkComp],
  },
  {
    income: 'Foreign Income',
    columns: [null, null, null, null, checkMarkComp],
  },
  {
    income: 'Capital Gains (Foreign)',
    columns: [null, null, null, null, checkMarkComp],
  },
];

export const ITR_2_PRICE_TABLE_BODY: TPRICE_TABLE_BODY[] = [
  {
    income: 'Taxable Income < 5L',
    columns: [checkMarkComp, checkMarkComp, checkMarkComp, checkMarkComp],
  },
  {
    income: 'Taxable Income > 5L',
    columns: [checkMarkComp, checkMarkComp, checkMarkComp, checkMarkComp],
  },
  {
    income: 'Self Employed Income',
    columns: [checkMarkComp, checkMarkComp, checkMarkComp, checkMarkComp],
  },
  {
    income: 'Business Income',
    columns: [checkMarkComp, checkMarkComp, checkMarkComp, checkMarkComp],
  },
  {
    income: 'Capital Gains (Indian)',
    columns: [checkMarkComp, checkMarkComp, checkMarkComp, checkMarkComp],
  },
  {
    income: 'Crypto Income (Transactions < 5K)',
    columns: [null, checkMarkComp, checkMarkComp, checkMarkComp],
  },
  {
    income: 'Crypto Income (Transactions > 5K)',
    columns: [null, null, checkMarkComp, checkMarkComp],
  },
  {
    income: 'Foreign Income',
    columns: [null, null, null, checkMarkComp],
  },
  {
    income: 'Capital Gains (Foreign)',
    columns: [null, null, null, checkMarkComp],
  },
];
